import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/apt/complex/[name]/error.tsx");
